import { ORGANIZATION } from '../hooks/env-variables'
import { baseFeatures, extraFeatures } from './features'

export const configs = {
  'pgs-milano': {
    name: 'PGS Milano',
    website: 'https://www.pgsmilano.org',
    piattaforma: 'https://volley.pgsmilano.org',
    features: {
      ...baseFeatures,
      ...extraFeatures,
    },
  },
  'pgs-varese': {
    name: 'PGS Varese',
    website: 'https://www.varese-pgslombardia.org',
    piattaforma: 'https://volley.varese-pgslombardia.org',
    features: {
      ...baseFeatures,
      ...extraFeatures,
      arbitraggi: false,
      corsi: false,
    },
  },
}

export const isValidOrganization = Object.keys(configs)?.includes(ORGANIZATION)

export const config = configs?.[ORGANIZATION]

export const handleInvalidOrganization = () => {
  const errorDiv = document.createElement('div')
  errorDiv.style.padding = '20px'
  errorDiv.style.margin = '50px auto'
  errorDiv.style.maxWidth = '600px'
  errorDiv.style.color = '#b71c1c'
  errorDiv.style.border = '1px solid #f44336'
  errorDiv.style.backgroundColor = '#ffebee'
  errorDiv.innerHTML = `
        <h2>Piattaforma fuori servizio</h2>
        Si prega di riprovare più tardi o contattarci se il problema persiste.
      `

  document.body.innerHTML = ''
  document.body.appendChild(errorDiv)

  throw new Error('Errore di configurazione')
}
